import React, { useState, useCallback } from 'react';
import './styles.css';
import { calcScore, calcDiscount, scoreLevel } from './data';

import LandingScreen        from './screens/LandingScreen';
import LoginScreen          from './screens/LoginScreen';
import HomeScreen           from './screens/HomeScreen';
import ConnectScreen        from './screens/ConnectScreen';
import WorkshopsScreen      from './screens/WorkshopsScreen';
import WorkshopDetailScreen from './screens/WorkshopDetailScreen';
import BookingScreen        from './screens/BookingScreen';
import ProfileScreen        from './screens/ProfileScreen';

function IconHome() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
}
function IconWrench() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>;
}
function IconLink() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>;
}
function IconUser() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
}

const NAV_ITEMS = [
  { key:'home',      label:'Início',   Icon:IconHome   },
  { key:'workshops', label:'Oficinas', Icon:IconWrench },
  { key:'connect',   label:'Apps',     Icon:IconLink   },
  { key:'profile',   label:'Perfil',   Icon:IconUser   },
];

export default function App() {
  const [user, setUser]         = useState(null);
  const [screen, setScreen]     = useState('landing');
  const [navTab, setNavTab]     = useState('home');
  const [wFilter, setWFilter]   = useState('Todos');
  const [connectedApps, setConnectedApps] = useState({ uber:false, taxi99:false });
  const [uberData]   = useState({ rides:1240, rating:4.87, years:3 });
  const [taxi99Data] = useState({ rides:430,  rating:4.72, years:2 });
  const [selWorkshop, setSelWorkshop] = useState(null);
  const [selService,  setSelService]  = useState(null);
  const [toast, setToast]       = useState(null);

  const showToast = useCallback((msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 3200);
  }, []);

  const totalRides = (connectedApps.uber ? uberData.rides : 0) + (connectedApps.taxi99 ? taxi99Data.rides : 0);
  const avgRating  = connectedApps.uber && connectedApps.taxi99
    ? (uberData.rating + taxi99Data.rating) / 2
    : connectedApps.uber ? uberData.rating : connectedApps.taxi99 ? taxi99Data.rating : 0;
  const maxYears   = Math.max(connectedApps.uber ? uberData.years : 0, connectedApps.taxi99 ? taxi99Data.years : 0);
  const score      = (connectedApps.uber || connectedApps.taxi99) ? calcScore({ rides:totalRides, rating:avgRating, years:maxYears }) : 0;
  const discount   = calcDiscount(score);
  const { label:scoreLvl, color:scoreColor } = scoreLevel(score);
  const scoreProps = { score, scoreColor, scoreLvl, discount, totalRides, avgRating, maxYears };

  function goNav(tab, filter) { setNavTab(tab); setWFilter(filter || 'Todos'); setScreen(tab); }

  function renderScreen() {
    switch (screen) {
      case 'landing':
        return <LandingScreen onLogin={() => setScreen('login')} onRegister={() => setScreen('login')} />;
      case 'login':
        return <LoginScreen onBack={() => setScreen('landing')} onSuccess={(u, isNew) => { setUser(u); setScreen('home'); setNavTab('home'); showToast(isNew ? 'Conta criada! 🎉' : 'Bem-vindo de volta! 👋'); }} />;
      case 'home':
        return <HomeScreen user={user} connectedApps={connectedApps} onNavigate={goNav} onWorkshopClick={w => { setSelWorkshop(w); setScreen('workshop-detail'); }} {...scoreProps} />;
      case 'connect':
        return <ConnectScreen connectedApps={connectedApps} uberData={uberData} taxi99Data={taxi99Data} onConnect={key => { setConnectedApps(p => ({ ...p, [key]:true })); showToast(`${key === 'uber' ? 'Uber' : '99'} conectado! 🔗`); }} {...scoreProps} />;
      case 'workshops':
        return <WorkshopsScreen discount={discount} initialFilter={wFilter} onWorkshopClick={w => { setSelWorkshop(w); setScreen('workshop-detail'); }} />;
      case 'workshop-detail':
        return <WorkshopDetailScreen workshop={selWorkshop} discount={discount} onBack={() => setScreen('workshops')} onBook={(w, s) => { setSelWorkshop(w); setSelService(s); setScreen('booking'); }} />;
      case 'booking':
        return <BookingScreen workshop={selWorkshop} service={selService} discount={discount} onBack={() => { setScreen('home'); setNavTab('home'); }} onConfirm={() => showToast('Agendamento confirmado! ✅')} />;
      case 'profile':
        return <ProfileScreen user={user} {...scoreProps} onNavigateConnect={() => goNav('connect')} onLogout={() => { setUser(null); setConnectedApps({ uber:false, taxi99:false }); setScreen('landing'); }} />;
      default: return null;
    }
  }

  const showBottomNav = user && !['landing','login','booking','workshop-detail'].includes(screen);

  return (
    <div style={{ minHeight:'100vh', background:'var(--black)' }}>
      {toast && <div className="toast">{toast}</div>}
      {renderScreen()}
      {showBottomNav && (
        <nav className="bottom-nav">
          {NAV_ITEMS.map(({ key, label, Icon }) => (
            <button key={key} className={`bottom-nav-item ${navTab === key ? 'active' : ''}`} onClick={() => goNav(key)}>
              <Icon />
              {label}
            </button>
          ))}
        </nav>
      )}
    </div>
  );
}
